import { render, staticRenderFns } from "./DashboardVerifyEmailAlert.vue?vue&type=template&id=7f3bf907"
import script from "./DashboardVerifyEmailAlert.vue?vue&type=script&lang=js"
export * from "./DashboardVerifyEmailAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports